<template>
  <el-row>
    <el-col :span="6">
      <el-upload
          class="upload-demo"
          drag
          ref="uploadMutiple"
          :file-list="fileList"
          :limit="limit"
          :data="postData"
          :action="qiniuHost"
          :on-success = "uploadSuccess"
      >
        <i class="el-icon-upload"></i>
<!--        <textarea  @paste="handlePaste"></textarea>-->
        <div class="el-upload__text" >将文件拖到此处，或<em>点击上传</em></div>
        <!--      <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>-->
      </el-upload>
      <div id="preview" @paste="handlePaste">
        <span><i class="el-icon-s-opportunity" style="color:#FB894C"></i>点击此处 将图片按Ctrl+V 粘贴至此处</span>
      </div>
    </el-col>
    <el-col :span="6" v-if="uploadedLink === ''">
      上传文件后，自动添加时间戳水印
    </el-col>
    <el-col :span="6" v-if="uploadedLink !== ''">
      <el-card :body-style="{ padding: '0px' }">
        <img :src="uploadedLink" style="width: 200px;height: 300px">
        <div style="padding: 14px;">
          <div class="bottom clearfix">
            <el-button type="primary" icon="el-icon-document-copy" @click="copyUrl"
                       >复制图片地址</el-button>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import axios from 'axios'
// import dayjs from 'dayjs'

export default {
  name: "watermarkTools",
  data() {
    return {
      postData: {
        token: ''
      },
      qiniuHost:'upload.qiniup.com',
      uploadedLink: '',
      fileList: [],
      limit: 1,
    };
  },
  methods: {
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        this.$message.error("粘贴内容非图片");
        return;
      }
      if(this.fileList.length>=1){
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`); // 图片数量超出
        return
      }
      this.$refs.uploadMutiple.handleStart(file);// 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit(); // 提交图片上传队列
    },
    copyUrl() {
      this.$clipboard(this.uploadedLink)
    },
    uploadSuccess(res) {
      // const text = dayjs(file.raw.lastModified).format('YYYY/MM/DD HH:mm:ss')
      this.uploadedLink = 'https://cyinimg.cyipp.com/'+res.key
      // this.uploadedLink = 'https://cyinimg.cyipp.com/'+res.key+'?watermark/4/text/'+Base64.encode(text)+'/font/5a6L5L2T/fontsize/400/fill/Z3JheQ==/dissolve/50/rotate/30/uw/180/uh/180/resize/1'
    },
    getUploadToken() {
      let _this = this;
      axios
          .get("/api/generateUploadToken")
          .then((content) => {
            console.log(content)
              _this.postData.token = content.data;
          });
    },
  },
  mounted() {
    let protocol = 'https://'
    if (window.location.protocol === 'http:') {
      // 在这里添加您想要执行的操作，比如重定向到 HTTPS 页面
      // 或者显示警告信息提示用户切换到 HTTPS
      protocol = "http://"
    }

    this.qiniuHost  = protocol + this.qiniuHost;

    this.getUploadToken();
  },
};
</script>
